import * as React from "react";
import { Link } from "react-router-dom";
import ArchiveStore from "../../../../stores/ArchiveStore";
import { GetArchiveList } from "../../../../actions/ArchiveActions";
class ArchiveSidebar extends React.Component {
  //isList: Array<BPModel>;
  constructor(props) {
    super(props);
    this.state = {
      archiveList: [],
      archivesLoaded: false
    };
    this.onReceiveArchiveChange = this.onReceiveArchiveChange.bind(this);
  }
  componentDidMount() {
    ArchiveStore.addChangeListener(this.onReceiveArchiveChange);
    GetArchiveList();
  }
  componentWillUnmount() {
    ArchiveStore.removeChangeListener(this.onReceiveArchiveChange);
  }
  onReceiveArchiveChange() {
    let lastChange = ArchiveStore.lastChange();
    if (lastChange === "ArchiveList") {
      let arch = ArchiveStore.getArchives();
      this.setState({
        archiveList: arch,
        archivesLoaded: true
      });
    }
  }
  render() {
    let listOfArchs;
    if (this.state.archiveList !== void 0) {
      listOfArchs = this.state.archiveList.map((dir) => /* @__PURE__ */ React.createElement("div", { style: { marginBottom: "8px" }, key: dir.archiveId }, /* @__PURE__ */ React.createElement(
        Link,
        {
          className: "sidebar-link",
          to: "/Admin/ArchiveView/" + dir.archiveId,
          style: { cursor: "Pointer", wordWrap: "break-word" }
        },
        /* @__PURE__ */ React.createElement(
          "i",
          {
            style: { color: "#86AFC0" },
            className: "fa-solid fa-archive"
          }
        ),
        " ",
        dir.rootPath,
        " ",
        dir.isCurrent && /* @__PURE__ */ React.createElement(
          "i",
          {
            style: { color: "#36AB26" },
            className: "fa-solid fa-check"
          }
        )
      )));
    } else {
      listOfArchs = /* @__PURE__ */ React.createElement("div", null, "No archives defined");
    }
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "d-flex flex-column p-3 text-white bg-dark",
        style: { height: "100%", width: "245px" }
      },
      /* @__PURE__ */ React.createElement(
        Link,
        {
          to: "/Admin/Directories",
          className: "d-flex align-items-center mb-3 mb-md-0 me-md-auto text-white text-decoration-none"
        },
        /* @__PURE__ */ React.createElement("span", { className: "fs-4" }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-archive" }), "   ", "Archives")
      ),
      /* @__PURE__ */ React.createElement("hr", null),
      /* @__PURE__ */ React.createElement("div", { style: { maxHeight: "50%", overflow: "auto" } }, listOfArchs),
      /* @__PURE__ */ React.createElement("hr", null),
      /* @__PURE__ */ React.createElement(Link, { className: "sidebar-link", to: "/Admin/ArchiveView/0" }, "New Archive")
    );
  }
}
export default ArchiveSidebar;
